// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwFlyoutButton-wrap"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwflyoutbutton/CwFlyoutButton.scss
// module id = 369
// module chunks = 0